import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { alertMessages } from '../helpers/common-constants';
@Injectable({
  providedIn: 'root',
})
export class ErrorUtilsService {
  static catchError(error: HttpErrorResponse) {
    if (error instanceof Error) {
      console.error('An error occurred:', error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `message: ${error.statusText}`);
    }
    return throwError(error.status);
  }

  getErrorMessage(error: any): string {
    let message = alertMessages.INTERNAL_SERVER_ERROR.toString();
    try {
      if (typeof error === 'string') {
        error = JSON.parse(error);
      } else if (typeof error.developerMessage === 'string') {
        error.developerMessage = JSON.parse(error.developerMessage);
      }
    } catch (e) {
      return message;
    }

    if (error?.error) {
      message = error.error.message ? error.error.message : 'An unknown error occurred:  ' + error.error;
    } else if (error?.status) {
      message = error.status;
    } else if (error?.code === 400 || 
               error?.code === 404 || 
               error?.code === 409) {
      if (error.developerMessage?.status) {
        message = error.developerMessage.status;
      }
    }

    return message;
  }
}
